import { apiClient } from "../../../api/client";
import * as ActionType from "./fakeProduct.type";
import { setToast } from "../../../util/toast";

// GET ALL PRODUCT
export const getFakeProduct = (start, limit) => async (dispatch) => {
  const res = await apiClient.get(
    `product/getFakeProducts?start=${start}&limit=${limit}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_FAKE_PRODUCT,
      payload: res.data,
      totalProduct: res.data?.totalProducts,
    });
  } else {
    console.error(res.message);
  }
};

// CREATE_CATEGORY
export const createFakeProduct = (formData) => async (dispatch) => {
  const res = await apiClient.post("product/createProductByAdmin", formData);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.CREATE_FAKE_PRODUCT,
      payload: res.data.product,
    });
    setToast("success", "Product Create successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// UPDATE_CATEGORY
export const updateFakeProduct =
  (formData, id, sellerId, productCode) => async (dispatch) => {
    const res = await apiClient.patch(
      `product/update?productId=${id}&sellerId=${sellerId}&productCode=${productCode}`,
      formData
    );

    if (res.ok && res.data?.status) {
      dispatch({
        type: ActionType.UPDATE_FAKE_PRODUCT,
        payload: { data: res.data.product, id },
      });
      setToast("success", "Product update successfully");
    } else {
      setToast("error", res.data?.message || res.message);
    }
  };

// DELETE_CATEGORY
export const deleteFakeProduct = (id) => async (dispatch) => {
  const res = await apiClient.delete(`product/delete?productId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DELETE_FAKE_PRODUCT,
      payload: id,
    });
    setToast("success", "Product Delete successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_NEW_COLLECTION
export const FakeNewCollection = (product, collection) => async (dispatch) => {
  const res = await apiClient.patch(`product/isNewCollection?productId=${product}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.FAKE_PRODUCT_NEW_COLLECTION,
      payload: { data: res.data.product, id: collection._id },
    });

    setToast(
      "success",
      `${collection?.seller?.firstName} Is ${
        res.data.product.isNewCollection == true
          ? "Add New Collection"
          : "Remove New Collection"
      } Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_OUT OF STOCK
export const FakeOutOfStock = (product, stock) => async (dispatch) => {
  const res = await apiClient.patch(`product/isOutOfStock?productId=${product}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.FAKE_PRODUCT_OUT_OF_STOCK,
      payload: { data: res.data.product, id: stock._id },
    });

    setToast(
      "success",
      `${stock?.seller?.firstName} Is ${
        stock.isOutOfStock == true ? "Instock Product" : "Out Of Stock Product"
      } Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// PRODUCT_DETAIL
export const getProductDetail = (id) => async (dispatch) => {
  const res = await apiClient.get(`product/productDetailsForAdmin?productId=${id}`);
  if (res.ok) {
    dispatch({
      type: ActionType.FAKE_PRODUCT_DETAIL,
      payload: res.data?.product,
    });
  } else {
    console.error(res.message);
  }
};

// PRODUCT_REVIEW
export const getFakeProductReview = (id, start, limit) => async (dispatch) => {
  const res = await apiClient.get(
    `review/getreview?productId=${id}&start=${start}&limit=${limit}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.FAKE_PRODUCT_REVIEW,
      payload: res.data?.reviews,
    });
  } else {
    console.error(res.message);
  }
};
